import {useState} from 'react';
import {Col, FormGroup, Label, CustomText, Input} from '@polichat/flamboyant';
import { useGlotaT } from '../../../../../hooks/useGlotaTranslation';

function TemplateTagInput({onUpdate, initialValue}) {
  // Traduções
  const tag = useGlotaT('spa.messageBuilder.tag');
  const tagPlaceholder = useGlotaT('spa.messageBuilder.tagPlaceholder');
  
  const [templateTag, setTemplateTag] = useState({
    templateTag: initialValue
  });

  const handleInputChange = ({target: {name, value}}) => {
    setTemplateTag({
      ...templateTag,
      [name]: value
    });
    handleTemplateTagData({
      ...templateTag,
      [name]: value
    })
  };

  const handleTemplateTagData = (data) => {
    onUpdate(data)
  }

  return (
  <Col sm={12} md={6} >
    <FormGroup>
      <Label>{tag}</Label>
      <Input
        type="text"
        id="template-tag"
        name= "templateTag"
        placeholder={tagPlaceholder}
        value={templateTag.templateTag}
        onChange={handleInputChange}
        required
        />
    </FormGroup>
  </Col>
)}

export default TemplateTagInput;
